<template>
  <div id="finalisation-screen">
    <div class="container">
      <div v-if="selectedInspection && commonData" class="row">
        <div v-if="selectedInspection && selectedInspection.status === 'completed'" class="row hidden-print text-right">
          <div class="col-12 print-row">
            <base-button
              :disabled="editable"
              :title="$t('app.inspection_memo.buttons.print')"
              :classNames="`btn btn-orange rounded finalize-button`"
              @clicked="print"
            />
          </div>
        </div>
        <inspection-head
        <report-list
          :statements="selectedInspection.inspections_statements"
          :readOnly="!editable"
          @updateResult="updateResultClicked"
          @updateTask="updateTaskClicked"
          @updateMemoClicked="updateMemoClicked"
        />
        <div v-if="selectedInspection && workers">
          <participant-list
            v-if="editable"
            :participants="selectedInspection.participants"
            :workers="selectedInspection.site_users"
            @updateParticipants="updateParticipants"
          />
        </div>
        <inspection-report-summary :data="selectedInspection"/>
        <div  v-if="selectedInspection && selectedInspection.status === 'done' && editable" class="row">
          <div class="col-12 note-field mt-30">
            <base-textarea
              ref="noteArea"
              v-model="note"
              :labelClassNames="'note-label'"
              :labelValue="$t('app.inspection_note.addNote')"/>
          </div>
        </div>
        <div v-if="selectedInspection && selectedInspection.status === 'done' && editable" class="row">
          <div class="col-12 pull-right note-field">
            <base-button
              :title="$t('app.inspection_note.button')"
              :classNames="this.note === undefined
                ? 'btn btn-default rounded finalize-button mb-20 button-disabled' : 'btn btn-orange rounded finalize-button mb-20'"
              @clicked="createNote"
            />
          </div>
        </div>
        <div v-if="selectedInspectionNotes.length > 0" class="panel panel-default border-panel card-view note-row">
          <div class="panel-wrapper collapse in">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-12 header-row">
                  <div class="pull-left">
                    <h6 class="panel-title txt-dark">
                      <span>{{$t(`app.inspection_note.title`)}}</span>
                    </h6>
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="panel-body">
              <div class="table-wrap mt-10">
                <div class="table-responsive participant-table">
                  <table class="table mb-0 note-table">
                    <tbody>
                      <tr
                        style="width: 100%"
                        class="table-row"
                        v-for="(note, index) in this.selectedInspectionNotes"
                        :key="index"
                      >
                        <td style="width:95%">
                          <span>{{note.note}}</span>
                        </td>
                        <td v-if="selectedInspection.status !== 'completed' && editable" class="action-field" style="width:5%">
                          <i class="zmdi zmdi-delete action-button" @click="deleteNote(note.id)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-30">
          <approved-specializations
            :specializations="inspectionSpecializations"/>
        </div>
        <div v-if="editable === false" class="panel panel-default border-panel card-view">
          <div class="panel-wrapper collapse in">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-12 participants-title">
                  <div class="pull-left">
                    <h6 class="panel-title txt-dark" style="font-weight: bold;">
                      <span>{{$t(`app.inspection_statement.participants.title`)}}</span>
                    </h6>
                  </div>
                  <div class="pull-right"></div>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="panel-body participant-body">
              <div class="table-wrap mt-10">
                <div class="table-responsive participant-table">
                  <table class="table mb-0">
                    <thead>
                      <tr style="width: 100%">
                        <th class="name">
                          <span>{{$t(`app.inspection_statement.participants.name`)}}</span>
                        </th>
                        <th class="phone">
                          <span>{{$t(`app.inspection_statement.participants.phone`)}}</span>
                        </th>
                        <th class="email">
                          <span>{{$t(`app.inspection_statement.participants.email`)}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        style="width: 100%"
                        class="table-row"
                        v-for="(person, index) in selectedInspection.participants"
                        :key="index"
                      >
                        <td>
                          <span>{{person.name}}</span>
                        </td>
                        <td>
                          <span>{{person.phone}}</span>
                        </td>
                        <td>
                          <span>{{person.email}}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasPermission && editable && selectedInspection && selectedInspection.status !== 'completed'" class="row text-right">
        <div class="col-12 submit-row">
          <base-button
            :title="$t('app.inspection_memo.buttons.done')"
            :classNames="`btn btn-orange rounded finalize-button`"
            @clicked="finalize"
          />
        </div>
      </div>
      <div v-if="canRemoveApproval && editable && selectedInspection && selectedInspection.status !== 'completed'" class="row text-right">
        <div class="col-12 submit-row">
          <base-button
            :title="$t('app.inspections.approve.remove_approval')"
            :classNames="`btn btn-orange rounded finalize-button`"
            @clicked="removeApprovalClicked"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BaseButton from '@/components/shared/buttons/BaseButton';
import GenericForm from '@/components/shared/forms/GenericForm';
import InspectionReportList from '@/components/shared/lists/InspectionReportList';
import BaseDropdown from '@/components/shared/inputs/BaseDropDown';
import BaseTextarea from '@/components/shared/inputs/BaseTextArea';
import InspectionHeader from './InspectionHeader';
import InspectionReportSummary from './InspectionReportSummary';
import ParticipantList from './ParticipantList';
import ApprovedSpecializations from './ApprovedSpecializations';

export default {
  name: 'InspectionFinalisationScreen',
  components: {
    'inspection-header': InspectionHeader,
    'inspection-report-summary': InspectionReportSummary,
    'base-button': BaseButton,
    'participant-list': ParticipantList,
    'report-list': InspectionReportList,
    'base-dropdown': BaseDropdown,
    'base-textarea': BaseTextarea,
    ApprovedSpecializations,
  },
  props: {},
  data() {
    return {
      newMemo: {
        text: undefined,
      },
      newNote: {
        note: undefined,
      },
      note: undefined,
      currentPageIndex: 1,
      searchTerm: '',
      partnerId: undefined,
      siteId: undefined,
      selectedInspection: null,
      selectedInspectionNotes: [],
      finalizedMemos: [],
      workers: undefined,
      participantIds: [],
      editable: true,
      storedInspectionStatementId: undefined,
      results: [
        {
          value: 'unknown',
          text: this.$t('app.inspection_statement.results.unknown'),
        },
        {
          value: 'matched',
          text: this.$t('app.inspection_statement.results.matched'),
        },
        {
          value: 'mismatched',
          text: this.$t('app.inspection_statement.results.mismatched'),
        },
      ],
      inspectionSpecializations: undefined,
    };
  },
  created() {
    if (this.$route.name === 'InspectionReportScreen' || this.isVivu) {
      this.editable = false;
    }
    this.initInspection();
    this.fetchInspectionNotes(this.$route.params.id).then((notes) => {
      this.selectedInspectionNotes = notes;
    });
  },
  mounted() {},
  computed: {
    ...mapGetters({
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    canRemoveApproval() {
      let hasPermission = false;
      if (this.inspectionSpecializations === undefined || this.inspectionSpecializations.length === 0) {
        return false;
      }
      const inSpecs = this.inspectionSpecializations.filter(x => x.user !== null);
      const approvedSpecializations = inSpecs.map(x => x.specialization.name);
      approvedSpecializations.forEach((x) => {
        if (this.userSpecs.includes(x)) {
          hasPermission = true;
        }
      });
      return hasPermission;
    },
    isVivu() {
      return this.loggedInUser.role === 'vivu'
    },  
    hasPermission() {
      let hasPermission = false;
      if (this.inspectionSpecializations === undefined || this.inspectionSpecializations.length === 0) {
        return true;
      }
      const inSpecUsers = this.inspectionSpecializations.filter(x => this.userSpecs.includes(x.specialization.name) && x.user == null);
      if (inSpecUsers.length > 0) {
        hasPermission = true;
      }
      return hasPermission;
    },
    specs() {
      if (this.selectedInspection) {
        return this.selectedInspection.specializations.map(specialization => specialization.name);
      }
      return [];
    },
    userSpecs() {
      if (this.loggedInUser) {
        return this.loggedInUser.specializations.map(specialization => specialization.name);
      }
      return [];
    },
    vivuList() {
      const mappedVivus = this.commonData.user_list.map(user => ({
        value: user.id,
        text: user.name,
      }));
      return mappedVivus;
    },
    taskAttributes() {
      return [
        {
          name: 'name',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'deadline',
          type: 'date',
          classes: 'col-md-6',
        },
        {
          name: 'description',
          type: 'text',
          classes: 'col-md-6',
        },
        {
          name: 'assignee_user_id',
          type: 'dropdown',
          dropdownList: this.vivuList,
          classes: 'col-md-6',
        },
        {
          name: 'files',
          type: 'file',
          multiple: true,
        },
      ];
    },
    statementList() {
      const mappedStatements = this.selectedInspection.inspections_statements.map(
        inspectionStatement => inspectionStatement.statement,
      );
      return mappedStatements;
    },
    participantsForList() {
      return this.workers.map(worker => ({
        id: worker.id,
        text: worker.name,
      }));
    },
    inspectionAttributes() {
      return [
        {
          name: 'participants',
          type: 'tag',
          list: this.participantsForList,
        },
      ];
    },
    inspectionStatementAttributes() {
      return [
        {
          name: 'result',
          type: 'dropdown',
          dropdownList: this.results,
        },
      ];
    },
    memoAttributes() {
      return [
        {
          name: 'text',
          type: 'text-area',
        },
      ];
    },
    noteAttributes() {
      return [
        {
          name: 'note',
          type: 'text-area',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchTask: 'tasks/fetchTask',
      updateTaskParams: 'tasks/updateTask',
      fetchInspection: 'inspections/fetchInspection',
      finalizeInspection: 'inspections/finalizeInspection',
      removeApproval: 'inspections/removeApproval',
      fetchWorkers: 'users/fetchWorkers',
      updateInspectionStatementResult:
        'inspections/updateInspectionStatementResult',
      updateInspectionStatementMemo: 'inspections/updateInspectionStatementMemo',
      fetchInspectionNotes: 'inspection_notes/fetchInspectionNotes',
      fetchInspectionNote: 'inspection_notes/fetchInspectionNote',
      updateInspectionNote: 'inspection_notes/updateInspectionNote',
      createInspectionNote: 'inspection_notes/createInspectionNote',
      deleteInspectionNote: 'inspection_notes/deleteInspectionNote',
    }),
    initInspection() {
      this.fetchInspection({ id: this.$route.params.id }).then((inspection) => {
        this.selectedInspection = inspection;
        this.inspectionSpecializations = inspection.inspection_specializations;
        const memos = [];
        inspection.inspections_statements.forEach((insStatement) => {
          memos.push({
            id: insStatement.id,
            memos: insStatement.inspection_memos,
          });
        });
        inspection.participants.forEach((x) => {
          this.participantIds.push(x.id);
        });
        this.finalizedMemos = memos;
        this.partnerId = inspection.planner_user.partner_id;
        this.siteId = inspection.site_id;
        this.fetchWorkers({
          partnerId: this.partnerId,
          siteId: this.siteId,
          pageIndex: this.currentPageIndex,
          searchTerm: this.searchTerm,
        }).then((response) => {
          this.workers = response.users;
        });
      });
    },
    removeApprovalClicked() {
      this.$swal
        .fire({
          html: this.$t('app.inspections.removeApproval'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t(
            'app.notifications.general_confirm.cancel',
          ),
        }).then((result) => {
          if (result.value) {
            this.removeApproval({
              id: this.selectedInspection.id,
            }).then((response) => {
              this.selectedInspection = response;
              this.inspectionSpecializations = response.inspection_specializations;
              this.$eventBus.showNotification({
                notificationText: this.$t('app.inspections.success'),
                notificationType: 'success',
              });
            });
          }
        });
    },
    editTask(id) {
      this.fetchTask(id)
        .then((task) => {
          const condition = this.loggedInUser.role === 'worker' && task.assignee_user_id === this.loggedInUser.id;
          this.$eventBus.showModal({
            bind: {
              is: GenericForm,
              title: this.$t('app.tasks.edit_task'),
              fields: condition ? this.workerTaskAttributes : this.taskAttributes,
              model: task,
              submitTitle: this.$t('app.tasks.buttons.save'),
              cancelTitle: this.$t('app.tasks.buttons.cancel'),
              modelName: 'tasks',
            },
            on: {
              submit: this.updateTask,
            },
            width: '1000px',
          });
        })
        .catch((error) => {
        console.log(error)
          this.$swal
            .fire({
              html: error[0],
              type: 'error',
              showCloseButton: true,
              showCancelButton: false,
              showConfirmButton: false,
              focusConfirm: false,
            });
        });
    },
    updateTask(task) {
      this.updateTaskParams(task)
        .then(() => {
          this.fetchInspection({ id: this.$route.params.id }).then((inspection) => {
            this.selectedInspection = inspection;
            const memos = [];
            inspection.inspections_statements.forEach((insStatement) => {
              memos.push({
                id: insStatement.id,
                memos: insStatement.inspection_memos,
              });
            });
            inspection.participants.forEach((x) => {
              this.participantIds.push(x.id);
            });
            this.finalizedMemos = memos;
            this.partnerId = inspection.planner_user.partner_id;
            this.fetchWorkers({
              partnerId: this.partnerId,
              siteId: this.siteId,
              pageIndex: this.currentPageIndex,
              searchTerm: this.searchTerm,
            }).then((response) => {
              this.workers = response.users;
            });
          });
          this.$eventBus.hideModal();
        })
        .catch((error) => {
          this.$eventBus.stopLoading();
          const mappedErrors = error.map(x => ` ${x}`);
          this.$eventBus.getError(mappedErrors);
        });
    },
    print() {
      document.title = `${this.selectedInspection.identifier}_szemle`;
      window.print();
      // eslint-disable-next-line no-return-assign
      setTimeout(() => document.title = `SevesoRec | ${this.$t('app.inspections.title')}`, 1000);
    },
    finalize() {
      this.$swal
        .fire({
          html: this.$t('app.inspections.finalize'),
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: this.$t('app.notifications.general_confirm.ok'),
          cancelButtonText: this.$t(
            'app.notifications.general_confirm.cancel',
          ),
        }).then((result) => {
          if (result.value) {
            this.finalizeInspection({
              id: this.selectedInspection.id,
              inspections_statements_memos: this.finalizedMemos,
              participantIds: this.participantIds,
            }).then(() => {
              this.$eventBus.showNotification({
                notificationText: this.$t('app.inspections.success'),
                notificationType: 'success',
              });
              this.$router.push({ path: '/inspections' });
            });
          }
        });
    },
    updateResultClicked(payload) {
      const model = {...payload}
      this.$eventBus.showModal({
        bind: {
          is: GenericForm,
          title: this.$t('app.inspection_statement.set_result'),
          fields: this.inspectionStatementAttributes,
          model: model,
          submitTitle: this.$t('app.inspection_statement.buttons.save'),
          cancelTitle: this.$t('app.inspection_statement.buttons.cancel'),
          modelName: 'inspection_statement',
        },
        on: {
          submit: this.updateResult,
        },
      });
    },
    updateTaskClicked(task) {
      this.editTask(task.id);
    },
    updateResult(inspectionStatement) {
      this.updateInspectionStatementResult({
        params: {
          id: this.selectedInspection.id,
          result: inspectionStatement.result,
        },
        id: inspectionStatement.id,
      }).then(() => {
        this.initInspection();
        this.$eventBus.hideModal();
      });
    },
    updateParticipants(ids) {
      this.participantIds = ids;
    },
    updateMemoClicked(payload) {
      const model = {...payload.memo}
      if (model !== undefined) {
        this.storedInspectionStatementId = payload.inspectionStatementId;
        this.$eventBus.showModal({
          bind: {
            is: GenericForm,
            title: this.$t('app.inspection_memo.set_memo'),
            fields: this.memoAttributes,
            model: model,
            submitTitle: this.$t('app.inspection_memo.buttons.save'),
            cancelTitle: this.$t('app.inspection_memo.buttons.cancel'),
            modelName: 'inspection_memo',
          },
          on: {
            submit: this.updateMemo,
          },
        });
      } else {
        this.storedInspectionStatementId = payload.inspectionStatementId;
        this.$eventBus.showModal({
          bind: {
            is: GenericForm,
            title: this.$t('app.inspection_memo.set_memo'),
            fields: this.memoAttributes,
            model: this.newNote,
            submitTitle: this.$t('app.inspection_memo.buttons.save'),
            cancelTitle: this.$t('app.inspection_memo.buttons.cancel'),
            modelName: 'inspection_memo',
          },
          on: {
            submit: this.createMemo,
          },
        });
      }
    },
    updateMemo(memo) {
      this.updateInspectionStatementMemo({
        params: {
          id: this.selectedInspection.id,
          text: memo.text,
        },
        inspectionStatementId: this.storedInspectionStatementId,
        id: memo.id,
      }).then(() => {
        this.$eventBus.hideModal();
        this.initInspection();
      });
    },
    createMemo(memo) {
      this.updateInspectionStatementMemo({
        params: {
          id: this.selectedInspection.id,
          text: memo.text,
        },
        inspectionStatementId: this.storedInspectionStatementId,
        id: memo.id,
      }).then(() => {
        this.selectedInspection.inspections_statements.forEach((x) => {
          if (x.id === this.storedInspectionStatementId) {
            x.inspection_memos.push(memo);
          }
        });
        this.$eventBus.hideModal();
      });
    },
    createNote() {
      if (this.note !== undefined && this.note.match(/^ *$/) === null) {
        this.createInspectionNote({ id: this.$route.params.id, params: { note: this.note } }).then(() => {
          this.fetchInspectionNotes(this.$route.params.id).then((notes) => {
            this.selectedInspectionNotes = notes;
          }).then(() => {
            this.resetNewNote();
            this.$eventBus.hideModal();
          });
        });
      }
    },
    deleteNote(id) {
      this.deleteInspectionNote({ inspectionId: this.$route.params.id, id })
        .then(() => {
          this.fetchInspectionNotes(this.$route.params.id).then((notes) => {
            this.selectedInspectionNotes = notes;
          });
        });
    },
    resetNewNote() {
      const noteArea = this.$refs.noteArea;
      noteArea.clearContent();
      this.note = undefined;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
#finalisation-screen {
  .note-row {
    page-break-after: always;
  }

  .submit-row {
    margin: -12px;
    margin-top: 30px;
  }

  .print-row {
    margin: 7px;
    margin-top: 10px;
  }

  /deep/ .button-disabled {
    cursor: not-allowed !important;
  }
  .note-field {
    margin: 4px;
  }

  /deep/ .note-label {
    margin-bottom: 5px;
    color: #272B34;
    font-size: 14px;
    font-weight: bold;
  }
  .header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/ .rounded {
    border-radius: 4px;
  }

    .vue-tags-input {
      max-width: 100%;
    }
    & /deep/ .ti-input {
      border: none !important;
      input[type="text"] {
        font-family: 'Roboto', sans-serif !important;
      }
    }
    & /deep/ .ti-tag {
      background-color: var(--main-color) !important;
      .ti-tag-center {
        font-family: 'Roboto', sans-serif !important;
      }
    }
    & /deep/ .ti-deletion-mark {
      background-color: #ee234f !important;
    }
    & /deep/ .ti-tag:before {
      display: none !important;
    }

}
@media print {
  #finalisation-screen {
    overflow: hidden;
    font-size: 10px;
  }

  .participants-title {
    span {
      font-size: 13px;
    }
    padding-left: 0px;
  }

  .participant-body {
    padding-top: 0 !important;
  }

  .page-wrapper {
    padding: 0px 20px;
  }

  .button-disabled {
    display: none;
  }

  .action-field, .note-field {
    display: none;
  }

  .finalize-button {
    display: none;
  }

  .participant-table {
    td,
    th {
      font-size: 12px !important;
      border: 1px solid #eee !important;
    }

    .phone {
        width: 20% !important;
      }

      .autograph {
        width: 30% !important;
      }

      .name {
        width: 30% !important;
      }

      .email,
      .date {
        width: 30% !important;
      }
  }
  .action-button {
    cursor: pointer;
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/InspectionFinalisationScreen.vue